import { render, staticRenderFns } from "./KendaraanDetail.vue?vue&type=template&id=5ab76bd2&scoped=true&"
import script from "./KendaraanDetail.vue?vue&type=script&lang=js&"
export * from "./KendaraanDetail.vue?vue&type=script&lang=js&"
import style0 from "./KendaraanDetail.vue?vue&type=style&index=0&id=5ab76bd2&prod&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab76bd2",
  null
  
)

export default component.exports